<template>
    <transition name="fade">
        <div class="loading" v-if="show">
            <div class="spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>
        </div>
    </transition>
</template>

<style>

.loading {
  background-color: rgba(133, 129, 129, 0.7);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
}

.spinner {
  width: 40px;
  height: 40px;

  z-index: 9999;
  margin: 0 auto;
  top: 50%;
  position: relative;
}

.double-bounce1, .double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  
  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% { 
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% { 
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>
<script>

export default {
  name: 'Loading',
  components: {
  },
  props: {
  },
  data() {
    return {
      scrollTop: 0,
      show: false
    }
  },
  mounted() {
    if($('#page-init-loading').is(':visible')){
      this.show = false
    } else {
      this.show = true
    }
  },
  destroyed() {
    $("#page-init-loading").hide()
  },
  methods: {
  }
}
</script>